var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import ScrollableAnchor from 'react-scrollable-anchor';
import { feathersServices } from 'src/feathers';
import Card from 'antd/lib/card';
import Input from 'antd/lib/input';
import 'antd/lib/card/style/index.css';
import 'antd/lib/input/style/index.css';
import CardJoinListEvent from 'src/pages/PageWelcome/CardJoin/CardJoinListEvent';
import CardJoinSpinner from 'src/pages/PageWelcome/CardJoin/CardJoinSpinner';
var cardStyles = require('src/imports/styles/extend.card.scss');
var selfStyles = require('./styles.scss');
var CardJoin = (function (_super) {
    __extends(CardJoin, _super);
    function CardJoin(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            searchResults: [],
            isFetching: true,
        };
        _this.handleCreateUserEventRole = _this.handleCreateUserEventRole.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        return _this;
    }
    CardJoin.prototype.componentDidMount = function () {
        this.handleSearch();
    };
    CardJoin.prototype.handleCreateUserEventRole = function (uER) {
        return this.props.dispatch(feathersServices.userEventRoles.create(uER));
    };
    CardJoin.prototype.handleSearch = function (e, searchString) {
        var _this = this;
        var searchTerm = e ? e.currentTarget.value : searchString;
        if (e && searchTerm && searchTerm.length < 6) {
            return;
        }
        this.setState({ isFetching: true });
        clearTimeout(this.timer);
        this.timer = window.setTimeout(function () {
            _this.props.dispatch(feathersServices.events.find({
                query: {
                    subdomain: searchTerm || undefined,
                    $limit: searchTerm ? 1 : 6,
                    $sort: {
                        dateStart: -1,
                    },
                },
            }))
                .then(function (res) {
                _this.setState({
                    searchResults: res.value.data,
                    isFetching: false,
                });
            })
                .catch(function (err) {
                _this.setState({ isFetching: false });
            });
        }, 300);
    };
    CardJoin.prototype.render = function () {
        return (React.createElement(Card, { className: this.props.className },
            React.createElement(ScrollableAnchor, { id: 'CardJoin' },
                React.createElement("h2", { className: cardStyles.header }, "Join an event")),
            React.createElement("p", null, "Are you in the organizing team of an event hosted with CRIMP? Search and request for organizer access here. The event will have a dedicated crimp.rocks web address."),
            React.createElement("div", { className: selfStyles.input },
                React.createElement(Input, { size: 'large', addonBefore: 'https://', addonAfter: '.crimp.rocks', placeholder: 'event-address', onChange: this.handleSearch, onPressEnter: this.handleSearch })),
            this.state.isFetching
                ? React.createElement(CardJoinSpinner, null)
                : (React.createElement(CardJoinListEvent, { user: this.props.store.user, userEventRoles: this.props.store.userEventRoles, events: this.state.searchResults, handleCreateUserEventRole: this.handleCreateUserEventRole }))));
    };
    return CardJoin;
}(React.Component));
var mapStateToProps = function (state) {
    return {
        store: {
            user: state.workspaceMain.user && state.workspaceMain.user.data[0],
            userEventRoles: state.workspaceMain.userEventRoles && state.workspaceMain.userEventRoles.data,
        },
    };
};
export default connect(mapStateToProps)(CardJoin);



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageWelcome/CardJoin/index.tsx
// module id = 825
// module chunks = 0